import NumberFormat from "react-number-format";

export const Title = ({
  it,
  separacion_miles,
  separacion_decimales,
  simbolo,
}) => {
  const presupuestado = parseFloat(it?.total_a_pagar || 1);
  const ejecutado = parseFloat(it?.total_gasto_final || 0);
  const pagado = parseFloat(it?.total_pagado || 0);

  const avanceGastado = (ejecutado / presupuestado) * 100;
  const avancePagado = (pagado / presupuestado) * 100;

  return (
    <tr
      key={it.nombre}
      className="transition-colors bg-gray-200/40 uppercase font-semibold"
    >
      <td className="px-5 py-3">
        <p>{it.nombre}</p>
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-muted-foreground">
        {" "}
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right">
        <NumberFormat
          value={it.total_a_pagar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-orange-600">
        <NumberFormat
          value={it.total_gasto_final}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-blue-600">
        <NumberFormat
          value={it.total_por_gastar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-green-600">
        <NumberFormat
          value={it.total_pagado}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="num whitespace-nowrap px-3 py-3 text-right text-red-600">
        <NumberFormat
          value={it.total_por_pagar}
          displayType={"text"}
          thousandSeparator={separacion_miles}
          decimalSeparator={separacion_decimales}
          prefix={`${simbolo} `}
          fixedDecimalScale
          decimalScale={2}
        />
      </td>
      <td className="px-5 py-3">
        <div className="flex items-center gap-3">
          <div className="relative h-2 w-24 overflow-hidden rounded-full bg-gray-300">
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-orange-400"
              style={{ width: `${avanceGastado}%` }}
            />
            <div
              className="absolute inset-y-0 left-0 rounded-full bg-green-600"
              style={{ width: `${avancePagado}%` }}
            />
          </div>
          <span>
            <NumberFormat
              value={avanceGastado}
              displayType={"text"}
              thousandSeparator={","}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale
              suffix="%"
            />
          </span>
        </div>
      </td>
      <td></td>
    </tr>
  );
};
